import $ from "jquery";
import app from "./app";
import './vendors/jquery-date-time-picker.full.min.js';
import LazyLoad from "vanilla-lazyload";

// ---------------------------------------------------------
// Custom Functions for Front-End
// ---------------------------------------------------------
$(document).ready(function () {
  if($('#bank_transfer_p_company').length){
    $('#bank_transfer_p_company').select2({
      triggerChange: true,
      ajax: {
        url: '/expert/banks',
        data: function (params) {
          var query = {
            keyword: params.term,
            page: params.page || 1
          }
          return query;
        }
      },
    });
  }
  if($('#bank_branch_p_company').length){
    $('#bank_branch_p_company').select2({
      ajax: {
        url: '/expert/banks/branchs',
        data: function (params) {
          var query = {
            keyword: params.term,
            bank_id: $('#bank_transfer_p_company').val(),
            page: params.page || 1
          }
          return query;
        }
      },
    });
  }
  $("#bank_transfer_p_company").on("change", function () {
    $('#bank_branch_p_company').val('').trigger('change')
  });

  if($('.jsSelect3').length){
    $('.jsSelect3').select2({
      dropdownCssClass: 'select3WrapResults',
      placeholder: '選択する',
      templateResult: function (data, container) {
        if (data.element) {
          $(container).addClass($(data.element).attr('class'));
        }
        return data.text;
      }
    });    
  }
  if($(".dateTimePicker2").length){
    jQuery.datetimepicker.setLocale('ja');
    $(".dateTimePicker2").datetimepicker({
      timepicker:false,
      format:'Y-m-d',
      scrollMonth: false,
      scrollInput: false
    });
  }
});

const body = document.querySelector("body"),
  headerEl = document.getElementById("header"),
  footerEl = document.getElementById("footer"),
  contentsEl = document.getElementById("contents"),
  overplay = document.getElementById("overplay"),
  tabEl = document.getElementById("jsTab");

let heightContents = 0;
if(contentsEl){
  heightContents = contentsEl.offsetHeight;
}

function handleToggleForm() {
  const frmDone = document.getElementById('frmDone');
  const frmForm = document.getElementById('frmForm');
  if(frmDone && frmForm){
    frmDone.style.display = 'none';
    frmForm.style.display = 'block';
  }
}

function handleMinHeightContents() {
  if (contentsEl) {
    contentsEl.style.minHeight = `calc(100vh - ${
      headerEl.offsetHeight + footerEl.offsetHeight
    }px)`;
  }
}

function handleShowDefaultValue() {
  const input = document.getElementById("signupEmail");
  if (input) {
    let defaultValue = input.getAttribute("defaultValue");
    if(!input.value){
      input.value = defaultValue;
    }
  }
}

function handleResetModal() {
  const modals = document.querySelectorAll(".jsResetModal");
  if (modals) {
    modals.forEach(function (modal) {
      let inputs = modal.querySelectorAll("input");
      let texts = modal.querySelectorAll(".errorText");
      if (inputs) {
        inputs.forEach(function (input) {
          if(input.type == 'radio'){
            input.checked = false;
          } else {
            input.classList.remove("error");
            input.value = "";
          }
        });
      }
      if (texts) {
        texts.forEach(function (text) {
          text.classList.remove("show");
        });
      }
    });
  }
}

function handleDisableScroll() {
  const eleHtml = document.querySelector('html');
  eleHtml.style.overflowY = 'hidden';
}

function handleEnableScroll() {
  const eleHtml = document.querySelector('html');
  eleHtml.style.overflowY = 'visible';
}

function handleCloseModal(openModal, modal, overplay) {
  window.addEventListener("click", function (event) {
    if (
      !openModal.contains(event.target) &&
      !modal.contains(event.target) &&
      modal.classList.contains("active") &&
      overplay.classList.contains("active")
    ) {
      modal.classList.remove("active");
      overplay.classList.remove("active");
      if (modal.style.display) {
        modal.style.removeProperty('display');
      }
      handleEnableScroll();
      handleResetModal();
      handleToggleForm();
    }
  });
}

function handleModal() {
  const openModals = document.querySelectorAll(".openModal");
  const modals = document.querySelectorAll(".modal");
  if (openModals && modals) {
    openModals.forEach(function (openModal) {
      openModal.addEventListener("click", function (e) {
        e.stopPropagation();
        let dataId = openModal.getAttribute("dataId");
        let modal = document.getElementById(dataId);
        let closeEls = modal.querySelectorAll(".close");
        modal.classList.add("active");
        overplay.classList.add("active");
        handleDisableScroll();
        handleCloseModal(openModal, modal, overplay);
        closeEls.forEach(closeEl => {
          closeEl.addEventListener("click", function () {
            modal.classList.remove("active");
            overplay.classList.remove("active");
            if (modal.style.display) {
              modal.style.removeProperty('display');
            }
            handleEnableScroll();
            handleResetModal();
            handleToggleForm();
          });
        })
      });
    });
  }
}

function handleModalAlertExpert() {
  const listModalAlertExpert = document.getElementsByClassName('modalAlertExpert');
  if (listModalAlertExpert.length > 0) {
    const modalAlertExpert = listModalAlertExpert[0];
    overplay.classList.add("active");
    handleDisableScroll();
    const closeEls = modalAlertExpert.querySelectorAll(".close");
    closeEls.forEach(closeEl => {
      closeEl.addEventListener("click", function () {
        modalAlertExpert.classList.remove("active");
        overplay.classList.remove("active");
        handleEnableScroll();
        handleResetModal();
        handleToggleForm();
      });
    })
  }
}

function handleOpenModalLogin() {
  const btnOpenLogins = document.querySelectorAll(".btnOpenLogin");
  const openLogin = document.querySelector("[dataId=modalLogin]");
  const modalSignup = document.getElementById("modalSignup");
  if (btnOpenLogins && openLogin) {
    btnOpenLogins.forEach(function (btnOpenLogin) {
      btnOpenLogin.addEventListener("click", function (e) {
        e.stopPropagation();
        openLogin.click();
        handleDisableScroll();
        overplay.classList.add("active");
        handleResetModal();
        if(modalSignup){
          modalSignup.classList.remove('active');
        }
      });
    });
  }
}

function handleOpenModalSignUp() {
  const btnOpenSignUps = document.querySelectorAll(".btnOpenSignUp");
  const openSignUp = document.querySelector("[dataId=modalSignup]");
  const modalLogin = document.getElementById("modalLogin");
  if (btnOpenSignUps && openSignUp) {
    btnOpenSignUps.forEach(function (btnOpenSignUp) {
      btnOpenSignUp.addEventListener("click", function (e) {
        e.stopPropagation();
        openSignUp.click();
        handleDisableScroll();
        overplay.classList.add("active");
        handleResetModal();
        if(modalLogin){
          modalLogin.classList.remove('active');
        }
      });
    });
  }
}

function handleTogglePassword() {
  const fields = document.querySelectorAll(".inputPass");
  if (fields) {
    fields.forEach(function (field) {
      let inputEl = field.querySelector("input");
      let iconEye = field.querySelector(".icon");
      if(iconEye) {
        iconEye.addEventListener("click", function () {
          this.classList.toggle("show");
          if (inputEl.type === "password") {
            inputEl.type = "text";
          } else {
            inputEl.type = "password";
          }
        });
      }
    });
  }
}

function customDatepicker() {
  const datepicker = require("js-datepicker");
  const datepickerUis = document.querySelectorAll(".datepickerUi");
  if (datepickerUis) {
    datepickerUis.forEach((item) => {
      item.readOnly = true;
      const idEle = item.id;
      if (!item.classList.contains("hadDatepicker")) {
        item.classList.add("hadDatepicker");
        const picker = datepicker("#" + idEle, {
          overlayPlaceholder: "",
          formatter: (input, date) => {
            let year = parseInt(date.toLocaleString("default", { year: "numeric" }));
            let month = parseInt(date.toLocaleString("default", { month: "2-digit" }));
            let day = parseInt(date.toLocaleString("default", { day: "2-digit" }));
            if(month < 10){
              month = '0' + month;
            }
            if(day < 10){
              day = '0' + day;
            }
            let formattedDate = year + '-' + month + '-' + day;
            input.value = formattedDate;
          },
          customDays: ["日", "月", "火", "水", "木", "金", "土"],
          customMonths: [
            "1月",
            "2月",
            "3月",
            "4月",
            "5月",
            "6月",
            "7月",
            "8月",
            "9月",
            "10月",
            "11月",
            "12月",
          ],
          onSelect: (instance, date) => {
            const frmSearch = document.getElementById("searchProject");
            if (frmSearch) {
              frmSearch.submit()
            }
          }
        });
      }
    });
  }
}
function handleUpdateCareerClass(elements) {
  if(elements){
    elements.forEach((element, index) => {
      element.setAttribute('id', `career${[index]}`)
      element.querySelector('.jsErrorCompanyName').setAttribute('class', `textError jsErrorCompanyName company_name${[index]}`);
      element.querySelector('.jsErrorRecruitmentForm').setAttribute('class', `textError jsErrorRecruitmentForm recruitment_form${[index]}`);
      element.querySelector('.jsErrorWorkingTime').setAttribute('class', `textError jsErrorWorkingTime working_time_one${[index]} working_time_two${[index]}`);
      element.querySelector('.jsErrorDepartment').setAttribute('class', `textError jsErrorDepartment department${[index]}`);
      element.querySelector('.jsErrorPosition').setAttribute('class', `textError jsErrorPosition position${[index]}`);
      element.querySelector('.jsErrorWorkContent').setAttribute('class', `textError jsErrorWorkContent work_content${[index]}`);
      const inputRecruitments =  element.querySelectorAll('.radioList input');
      if(inputRecruitments){
        inputRecruitments.forEach((element1, index1) => {
          element1.setAttribute('name', `recruitment_form[${[index]}]`);
        })
      }
    })
  }

  const number = document.getElementById("number_row").value
  for (var i = 0; i <= number; i++) {
    $("#career"+i+" :input").each(function(e) {
      if(this.id.includes("company_name")) {
        this.setAttribute('name', `company_name[${[i]}]`)
      }
      if(this.id.includes("recruitment_form")) {
        this.setAttribute('name', `recruitment_form[${[i]}]`)
      }
      if(this.id.includes("working_time_one")) {
        this.setAttribute('name', `working_time_one[${[i]}]`)
      }
      if(this.id.includes("working_time_two")) {
        this.setAttribute('name', `working_time_two[${[i]}]`)
      }
      if(this.id.includes("department")) {
        this.setAttribute('name', `department[${[i]}]`)
      }
      if(this.id.includes("position")) {
        this.setAttribute('name', `position[${[i]}]`)
      }
      if(this.id.includes("work_content")) {
        this.setAttribute('name', `work_content[${[i]}]`)
      }
    });
  }
}

const number_row_el = document.getElementById("number_row");
let number_row_test = 0;
if(number_row_el){
  number_row_test = parseInt(number_row_el.value);
}

function handleAddFormCareer() {
  const groupEl = document.querySelector(".jsGroupCareer");
  const button = document.querySelector("#jsBtnAdd");
  if(number_row_el){
    let number_row = number_row_el !== null ? number_row_el.value : 0;
    let num = parseInt(number_row) + 1;
    if (groupEl && button) {
      button.addEventListener("click", function () {
        number_row_test += 1;
        if(number_row_test < 5) {
          number_row_el.value = number_row_test;
          var blockCareer = ``;
          blockCareer += `
            <div class="blockCareer" id="career${num}">
              <div class="table5">
                <table>
                  <tr>
                      <th>
                        <label class="ttl" for="company_name{${num}}">企業名</label>`;
                        // if(route != 'web.expert.individual_registror') {
                        //   blockCareer += `<span class="must">必須</span>`;
                        // }
                      blockCareer += `</th>
                      <td>
                        <input type="text" id="company_name${num}" name="company_name[${num}]" class="mw500">
                        <p class="jsErrorCompanyName textError company_name${num}">企業名を入力してください。</p>
                      </td>
                  </tr>
                  <tr>
                      <th>
                        <label class="ttl" for="empCareerAdd1${num}">雇用形態</label>`;
                        // if(route != 'web.expert.individual_registror') {
                        //   blockCareer += `<span class="must">必須</span>`;
                        // }
                      blockCareer += `</th>
                      <td>
                        <ul class="radioList" id="radioList${num}">
                          <li>
                            <span class="radioGroup">
                                <input type="radio" name="recruitment_form[${num}]" value="1" id="recruitment_form${num}1">
                                <label for="recruitment_form${num}1">正社員</label>
                            </span>
                          </li>
                          <li>
                              <span class="radioGroup">
                                  <input type="radio" name="recruitment_form[${num}]" value="2" id="recruitment_form${num}2">
                                  <label for="recruitment_form${num}2">契約社員</label>
                              </span>
                          </li>
                          <li>
                              <span class="radioGroup">
                                  <input type="radio" name="recruitment_form[${num}]" value="3" id="recruitment_form${num}3">
                                  <label for="recruitment_form${num}3">業務委託</label>
                              </span>
                          </li>
                          <li>
                              <span class="radioGroup">
                                  <input type="radio" name="recruitment_form[${num}]" value="4" id="recruitment_form${num}4">
                                  <label for="recruitment_form${num}4">経営者</label>
                              </span>
                          </li>
                        </ul>
                        <p class="textError jsErrorRecruitmentForm recruitment_form${num}">雇用形態を選択してください。</p>
                      </td>
                  </tr>
                  <tr>
                      <th>
                        <label class="ttl" for="working_time_one${num}">在籍期間</label>`;
                        // if(route != 'web.expert.individual_registror') {
                        //   blockCareer += `<span class="must">必須</span>`;
                        // }
                      blockCareer += `</th>
                      <td>
                          <div class="twoBox2">
                              <input class="dateTimePicker2 mw150" id="working_time_one${num}" type="text" name="working_time_one[${num}]" autocomplete="off">
                              <span class="space">〜</span>
                              <input class="dateTimePicker2 mw150" id="working_time_two${num}" type="text" name="working_time_two[${num}]" autocomplete="off">
                          </div>
                          <p class="textError jsErrorWorkingTime working_time_one${num} working_time_two${num}">在籍期間を入力してください。</p>
                      </td>
                  </tr>
                  <tr>
                      <th><label class="ttl" for="department${num}">所属部門</label></th>
                      <td>
                        <input type="text" id="department${num}" name="department[${num}]" class="mw500">
                        <p class="textError jsErrorDepartment department${num}"></p>
                      </td>
                  </tr>
                  <tr>
                      <th><label class="ttl" for="position${num}">役職</label></th>
                      <td>
                        <input type="text" id="position${num}" name="position[${num}]" class="mw500">
                        <p class="textError jsErrorPosition position${num}"></p>
                      </td>
                  </tr>
                  <tr>
                      <th class="alignTop">
                        <label class="ttl" for="work_content${num}">業務内容</label>`;
                        // if(route != 'web.expert.individual_registror') {
                        //   blockCareer += `<span class="must">必須</span>`;
                        // }
                      blockCareer += `</th>
                      <td>
                        <textarea id="work_content${num}" name="work_content[${num}]" class="mw500"></textarea>
                        <p class="textError jsErrorWorkContent work_content${num}">業務内容を入力してください。</p>
                      </td>
                  </tr>
                </table>
              </div>
              <span class="btnDelete" id="id_btn_del${num}">削除する</span>
            </div>
          `;
          num += 1;
          groupEl.insertAdjacentHTML("beforeend", blockCareer);
          $(".dateTimePicker2").datetimepicker({
            timepicker:false,
            format:'Y-m-d',
            scrollMonth: false,
            scrollInput: false
          });
          const id_btn_del = 'id_btn_del' + (num - 1);
          handleRemoveCareer(id_btn_del);
          const blockCareers = document.querySelectorAll('.blockCareer');
          handleUpdateCareerClass(blockCareers);
        } else {
          alert('履歴を5つ以内で追加してください。');
        }
      });
    }
  }
}

function handleRemoveCareer(id) {
  const button = document.getElementById(id);
  if(button){
    button.addEventListener("click", () => {
      button.closest(".blockCareer").remove();
      number_row_test -= 1;
      number_row_el.value = number_row_test;
      const blockCareers = document.querySelectorAll('.blockCareer');
      handleUpdateCareerClass(blockCareers);
    });
  }
}

function handleRemoveCareerFirst () {
  const buttons = document.querySelectorAll('.btnDeleteFirst');
  if(buttons && number_row_el){
    buttons.forEach(button => {
      button.addEventListener("click", () => {
        button.closest(".blockCareer").remove();
        number_row_test -= 1;
        number_row_el.value = number_row_test;
        const blockCareers = document.querySelectorAll('.blockCareer');
        handleUpdateCareerClass(blockCareers);
      });
    });
  }
}

function tabScroll() {
  if (tabEl) {
    if (window.scrollY > tabEl.offsetTop - 89) {
      tabEl.classList.add("sticky");
    } else {
      tabEl.classList.remove("sticky");
    }
  }
}

function addTabCurrent(tabCallEls, id) {
  tabCallEls.forEach((tabCallEl) => {
    if (tabCallEl.dataset.tab == id) {
      tabCallEl.classList.add("current");
    }
  });
}

function hashTab(tabCallEls, tabContentEls) {
  let hash = window.location.hash;
  if (hash) {
    app.removeCurrentClass(tabCallEls, "current");
    app.removeCurrentClass(tabContentEls, "show");
    hash = hash.substring(1);
    tabCallEls.forEach((tabCallEl) => {
      if (tabCallEl.dataset.tab == hash) {
        tabCallEl.classList.add("current");
      }
    });
    tabContentEls.forEach((tabContentEl) => {
      if (tabContentEl.id == hash) {
        tabContentEl.classList.add("show");
      }
    });
  }
}

function tabClick() {
  let tabCallEls = document.querySelectorAll(".jsTabCall"),
    tabContentEls = document.querySelectorAll(".jsTabContent");
  if (tabCallEls.length > 0) {
    tabCallEls.forEach((tabCallEl) => {
      //let disable_tab = $("#disable_tab").val();
      tabCallEl.addEventListener("click", function (e) {
        handleScrollSidebar3();
        e.preventDefault();
        //if (disable_tab == "true") {
        tabContentEls.forEach((tabContentEl) => {
          if (tabContentEl.id == tabCallEl.dataset.tab) {
            app.removeCurrentClass(tabCallEls, "current");
            app.removeCurrentClass(tabContentEls, "show");
            tabCallEl.classList.add("current");
            tabContentEl.classList.add("show");
            addTabCurrent(tabCallEls, tabCallEl.dataset.tab);
          }
        });
        //}
        handleAutoHeightTextarea({
          element: '.textareaGeneral2',
        });
      });
    });
    hashTab(tabCallEls, tabContentEls);
  }
}

function tabOrderClick() {
  let tabCallEls = document.querySelectorAll(".jsTabOrderCall"),
    tabContentEls = document.querySelectorAll(".jsTabOrderContent");
  if (tabCallEls.length > 0) {
    tabCallEls.forEach((tabCallEl) => {
      //let disable_tab = $("#disable_tab").val();
      tabCallEl.addEventListener("click", function (e) {
        e.preventDefault();
        //if (disable_tab == "true") {
        tabContentEls.forEach((tabContentEl) => {
          if (tabContentEl.id == tabCallEl.dataset.tab) {
            app.removeCurrentClass(tabCallEls, "current");
            app.removeCurrentClass(tabContentEls, "show");
            tabCallEl.classList.add("current");
            tabContentEl.classList.add("show");
            addTabCurrent(tabCallEls, tabCallEl.dataset.tab);
          }
        });
        //}
      });
    });
    hashTab(tabCallEls, tabContentEls);
  }
}

function tabCheckClick() {
  let tabCallEls = document.querySelectorAll(".jsTabCheckCall"),
    tabContentEls = document.querySelectorAll(".jsTabCheckContent");
  if (tabCallEls.length > 0) {
    tabCallEls.forEach((tabCallEl) => {
      // let disable_tab = $("#disable_tab").val();
      tabCallEl.addEventListener("click", function (e) {
        e.preventDefault();
        // if (disable_tab == "true") {
          tabContentEls.forEach((tabContentEl) => {
            if (tabContentEl.id == tabCallEl.dataset.tab) {
              app.removeCurrentClass(tabCallEls, "current");
              app.removeCurrentClass(tabContentEls, "show");
              tabCallEl.classList.add("current");
              tabContentEl.classList.add("show");
              addTabCurrent(tabCallEls, tabCallEl.dataset.tab);
            }
          });
        // }
      });
    });
    hashTab(tabCallEls, tabContentEls);
  }
}

function handlePageTop() {
  const pageTop = document.querySelector(".pageTop");
  if (pageTop) {
    let scroll = 0;
    window.addEventListener("scroll", function () {
      scroll = window.pageYOffset;
      if (scroll > 20) {
        pageTop.classList.add("sticky");
      } else {
        pageTop.classList.remove("sticky");
      }
    });
    pageTop.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      window.scroll({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    });
  }
}

function handleScrollSidebar() {
  const offsetHeightBody = body.offsetHeight;
  const wrapSidebar = document.querySelector(".wrapSidebar");
  const sidebar = document.querySelector(".jsSidebar");
  if(sidebar && wrapSidebar){
    const windowHeight = window.innerHeight;
    const footerTop = footerEl.offsetTop;
    const heightHeader = headerEl.offsetHeight;
    const heightFooter = footerEl.offsetHeight;
    const heightSidebar = sidebar.offsetHeight;
    const wrapTop = wrapSidebar.offsetTop - heightHeader - 20;
    if (sidebar && wrapSidebar && headerEl && heightContents > heightSidebar + 400) {
      let scroll = window.scrollY;
      let viewScreen = footerTop - heightHeader - scroll - 20;
      let wrapLeft = wrapSidebar.getBoundingClientRect().left;
      if (scroll >= wrapTop) {
        sidebar.classList.add("sticky");
        sidebar.style.top = heightHeader + 20 + "px";
        sidebar.style.left = wrapLeft + "px";
        sidebar.style.bottom = 'auto';
        if ( (scroll + windowHeight + 20) >= (offsetHeightBody - heightFooter) ) {
          if(heightSidebar >=  windowHeight || viewScreen <= heightSidebar) {
            sidebar.style.top = 'auto';
            sidebar.style.bottom = scroll + windowHeight - footerTop + 20 + 'px';
          }
        }
      } else {
        sidebar.classList.remove("sticky");
      }
    }
  }
}

function handleScrollSidebar2() {
  if(window.innerWidth > 992){
    const wrapSidebar = document.getElementById("jsWrapSidebar2");
    const sidebar = document.getElementById("jsSidebar2");
    const title = document.querySelector('#jsTitleSticky .jsTitle');
    let titleHeight = 0;
    if(title){
      titleHeight = title.offsetHeight;
    }
    if(sidebar && wrapSidebar){
      const windowHeight = window.innerHeight;
      const footerTop = footerEl.offsetTop;
      const heightHeader = headerEl.offsetHeight;
      const heightFooter = footerEl.offsetHeight;
      const heightSidebar = sidebar.offsetHeight;
      const wrapTop = wrapSidebar.offsetTop - heightHeader - titleHeight - 20;
      if (sidebar && wrapSidebar && headerEl && heightContents > heightSidebar + 200) {
        let scroll = window.scrollY;
        let wrapRight = wrapSidebar.getBoundingClientRect().right;
        if (scroll >= wrapTop) {
          sidebar.classList.add("sticky");
          sidebar.style.top = heightHeader + titleHeight + 20 + "px";
          sidebar.style.right = `calc( (100vw - (${wrapRight} + 'px')) / 2 ) `;
          sidebar.style.bottom = 'auto';
          if ( (scroll + heightSidebar + heightHeader + titleHeight + 20) >= (document.body.offsetHeight - heightFooter) ) {
            sidebar.style.top = 'auto';
            sidebar.style.bottom = scroll + windowHeight - footerTop + 20 + 'px';
          }
        } else {
          sidebar.classList.remove("sticky");
        }
      }
    }
  }
}

function handleScrollSidebar3() {
  const offsetHeightBody = body.offsetHeight;
  const wrapSidebar = document.querySelector(".wrapSidebar");
  const sidebar = document.querySelector(".jsSidebarRight");
  const contents = document.getElementById("contents");
  if(sidebar && wrapSidebar && contents && offsetHeightBody){
    const heightContent = contents.offsetHeight;
    const windowHeight = window.innerHeight;
    const footerTop = footerEl.offsetTop;
    const heightHeader = headerEl.offsetHeight;
    const heightFooter = footerEl.offsetHeight;
    const heightSidebar = sidebar.offsetHeight;
    const wrapTop = wrapSidebar.offsetTop - heightHeader - 20;
    if (sidebar && wrapSidebar && headerEl && heightContent >= (heightSidebar + 220) ) {
      let scroll = window.scrollY;
      let viewScreen = footerTop - heightHeader - scroll - 20;
      let wrapLeft = wrapSidebar.getBoundingClientRect().left;
      if (scroll >= wrapTop) {
        sidebar.classList.add("sticky");
        sidebar.style.top = heightHeader + 20 + "px";
        sidebar.style.left = wrapLeft + "px";
        sidebar.style.bottom = 'auto';
        if ( (scroll + windowHeight + 20) >= (offsetHeightBody - heightFooter) ) {
          if(heightSidebar >=  windowHeight || viewScreen <= heightSidebar) {
            sidebar.style.top = 'auto';
            sidebar.style.bottom = scroll + windowHeight - footerTop + 20 + 'px';
          }
        }
      } else {
        sidebar.classList.remove("sticky");
      }
    }
  }
}

let $lastScrollTop = 0;
let $flagSidebar = 0;
function handleScrollSidebar4() {
  const wrapSidebar = document.querySelector(".wrapSidebar");
  const sidebar = document.querySelector(".jsSidebar4");
  if(sidebar && wrapSidebar && contentsEl){
    if(window.innerWidth > 992){
      const windowHeight = window.innerHeight; // 929
      const footerTop = footerEl.offsetTop; // 3093 
      const heightHeader = headerEl.offsetHeight; // 79
      const wrapSidebarTop = wrapSidebar.offsetTop; // 272 
      const heightFooter = footerEl.offsetHeight; // 273
      const heightSidebar = sidebar.offsetHeight; // 884
      if(heightContents > heightSidebar + 400){
        const flag1 = (wrapSidebarTop - heightHeader); // 193
        const flag2 = (wrapSidebarTop + heightSidebar - windowHeight); // 227
        const flag3 = (footerTop - windowHeight); // 2164
        const flag4 = (footerTop - heightSidebar - heightFooter); // 1936
        let scroll = window.pageYOffset;
        if(scroll <= flag1 ){
          sidebar.classList.remove('fixed');
          sidebar.style.top = 'auto';
          sidebar.style.bottom = 'auto';
        } else {
          if( scroll >= flag2 ){
            if( scroll < flag3 ){
              sidebar.classList.add('fixed');
              sidebar.style.bottom = 0;
              sidebar.style.top = 'auto';
              if (scroll > $lastScrollTop) { // check down
                $flagSidebar = scroll;
              } else { // check up
                sidebar.classList.add('fixed');
                sidebar.style.top = heightHeader + 'px';
                sidebar.style.bottom = 'auto';
              }
            } else {
              sidebar.classList.remove('fixed');
              sidebar.style.bottom = 'auto';
              sidebar.style.top = flag4 + 'px';
            }
          }
        }
        $lastScrollTop = scroll <= 0 ? 0 : scroll; 
      }
    } else {
      return false;
    }
  }
}

function handleToggleActive() {
  const elements = document.querySelectorAll(".jsToggle");
  if (elements) {
    elements.forEach((element) => {
      element.addEventListener("click", (e) => {
        e.stopPropagation();
        element.classList.toggle("active");
      });
    });
  }
}

function handleToggleFavorite() {
  const elements = document.querySelectorAll(".jsFavorite");
  if (elements) {
    elements.forEach((element) => {
      element.addEventListener('click', event => {
        const textEle = element.querySelector('.text');
        event.stopPropagation();
        element.classList.toggle("active");
        if(textEle){
          if( element.classList.contains('active') ){
            textEle.textContent = 'お気に入り削除';
          } else {
            textEle.textContent = 'お気に入り追加';
          }
        }
      });
    });
  }
}

function handleToggleHistory() {
  const titleList = document.querySelectorAll("#jsHistoryPay .jsTitle");
  if(titleList){
    titleList.forEach( title => {
      title.addEventListener("click", e => {
        e.stopPropagation();
        const box = title.nextElementSibling;
        title.classList.toggle('active');
        if(title.classList.contains('active')){
          box.classList.add('active');
        } else {
          box.classList.remove('active');
        }
      });
    });
  }
}

function handleTriggerLink() {
  const elements = document.querySelectorAll(".jsTriggerLink");
  if (elements) {
    elements.forEach((element) => {
      element.addEventListener("click", (e) => {
        e.stopPropagation();
        let link = element.querySelector("a");
        if(link){
          link.click();
        }
      });
    });
  }
}

function rating() {
  let ratingEls = document.querySelectorAll(".jsRating");
  if (ratingEls.length > 0) {
    ratingEls.forEach((ratingEl) => {
      let point = ratingEl.dataset.point * 20;
      ratingEl.style.width = (90 / 100) * point + "px";
    });
  }
}

function handleClickButtonChoose() {
  const buttons = document.querySelectorAll('.btnChoose');
  if(buttons){
    buttons.forEach(button => {
      const button1 = button.querySelector('.item1');
      const button2 = button.querySelector('.item2');
      const icon = button.querySelector('.icon');
      if(button1.classList.contains('active')){
        icon.style.transform = 'translateX(0)';
        button1.style.color = '#FFF';
        button2.style.color = '#000';
      } else {
        icon.style.transform = 'translateX(64px)';
        button1.style.color = '#000';
        button2.style.color = '#FFF';
      }
      button1.addEventListener('mouseover', () => {
        icon.style.opacity = 1;
        button1.classList.add('loaded');
        button2.classList.add('loaded');
        if(!button1.classList.contains('active')){
          icon.style.transform = 'translateX(0)';
          button1.style.color = '#FFF';
          button2.style.color = '#000';
        }
      });
      button1.addEventListener('mouseout', () => {
        if(!button1.classList.contains('active')){
          icon.style.transform = 'translateX(64px)';
          button1.style.color = '#000';
          button2.style.color = '#FFF';
        }
      });
      button2.addEventListener('mouseover', () => {
        button1.classList.add('loaded');
        button2.classList.add('loaded');
        icon.style.opacity = 1;
        if(!button2.classList.contains('active')){
          icon.style.transform = 'translateX(64px)';
          button2.style.color = '#FFF';
          button1.style.color = '#000';
        }
      });
      button2.addEventListener('mouseout', () => {
        if(!button2.classList.contains('active')){
          icon.style.transform = 'translateX(0)';
          button2.style.color = '#000';
          button1.style.color = '#FFF';
        }
      });
    })
  }
}

function handleTextMore1 () {
  const blocks = document.querySelectorAll('.jsBlockTextMore1');
  if(blocks){
    blocks.forEach(block => {
      const boxText = block.querySelector('.jsBoxText');
      const heightBoxText = boxText.offsetHeight;
      const moreText = block.querySelector('.jsTextMore');
      if(heightBoxText >= 100){
        moreText.classList.add('show');
      }
      moreText.addEventListener('click', () => {
        boxText.style.maxHeight = 'inherit';
        moreText.classList.remove('show');
      })
    })
  }
}

function handleTestInputChecked(inputs) {
  let isChecked = true;
  inputs.forEach(input => {
    if(!input.checked){
      isChecked = false;
      return false;
    }
  })
  return isChecked;
}

function handleInputCheckAll() {
  const blocks = document.querySelectorAll(".jsInputCheck");
  if (blocks) {
    blocks.forEach(block => {
      const checkItems = block.querySelectorAll('.checkItem');
      const checkAll = block.querySelector('.checkAll');
      if (checkAll) {
        checkAll.addEventListener('change', () => {
          if(checkAll.checked){
            checkItems.forEach(checkItem => {
              checkItem.checked = true;
            })
          } else {
            checkItems.forEach(checkItem => {
              checkItem.checked = false;
            })
          }
        })
      }
      if (checkItems.length > 0) {
        checkItems.forEach(checkItem => {
          checkItem.addEventListener('change', () => {
            if(!checkItem.checked){
              checkAll.checked = false;
            } else {
              if(handleTestInputChecked(checkItems)){
                checkAll.checked = true;
              }
            }
          })
        })
      }
    })
  }
}

function handleFormEstimate() {
  const block = document.getElementById('estimateEdit');
  if(block){
    const textEdit = block.querySelector('.jsEditBtn');
    const form = block.querySelector('.formEstimate');
    const closeBtns = document.querySelectorAll('.closeBtn');
    if(textEdit && form && closeBtns){
      textEdit.addEventListener('click', () => {
        textEdit.classList.add('hide');
        form.classList.add('show');
      });
      closeBtns.forEach(closeBtn => {
        closeBtn.addEventListener('click', () => {
          form.classList.remove('show');
          textEdit.classList.remove('hide');
        })
      })
    }
  }
}

function handleToggleAppType() {
  const blocks = document.querySelectorAll('.jsAppType');
  if(blocks){
    blocks.forEach(block => {
      const items = block.querySelectorAll('.jsItem');
      const close = block.querySelector('.jsClose');
      if(items && close){
        items.forEach(item => {
          item.addEventListener('click', () => {
            item.classList.toggle('active');
          })
        });
        close.addEventListener('click', () => {
          items.forEach(item => {
            item.classList.remove('active');
          });
        })
      }
    })
  }
}

function handleTitleTicky1() {
  const block = document.getElementById('jsTitleSticky');
  if(headerEl && block){
    const headerHeight = headerEl.offsetHeight;
    const title = block.querySelector('.jsTitle');
    if(window.scrollY >= (block.offsetTop - headerHeight) ){
      title.classList.add('sticky');
      title.style.top = headerHeight + 'px';
      block.style.height = title.offsetHeight + 'px';
    } else {
      title.classList.remove('sticky');
      block.style.height = 'auto';
    }
  }
}

function handleChangeRadio1() {
  const radios = document.querySelectorAll('#jsRadioQuotaPresen input[type=radio]');
  const block = document.getElementById('jsBLockQuotaPresen');
  if(block && radios){
    radios.forEach(radio => {
      radio.addEventListener('change', () => {
        if( radio.checked ){
          if(radio.classList.contains('jsPresentFirst')){
            block.classList.add('active');
          } else {
            block.classList.remove('active');
          }
        }
      })
    })
  }
}

function handleChangeRadio2() {
  const block = document.querySelector('.jsRadioContract ');
  if(block){
    const block1 = document.querySelector('.jsBlock1 ');
    const block2 = document.querySelector('.jsBlock2 ');
    const radios = block.querySelectorAll('.jsOption');
    if(block1 && block2 && radios){
      const boxRequest = document.querySelector('#boxRequestContent .textarea');
      const dataTextAreaContent = {
        area1: '■クライアント事業概要\r\n例）大手アパレルメーカー。中価格帯ブランド軸を百貨店向け中心に展開。\r\n\r\n■クライアント区分 新規クライアントもしくは既存クライアントであるかを記載してください。\r\n\r\n■職務概要\r\n例）オムニチャネル化推進に伴う自社ウェブサイト・ECのマーケティング・運営・マネジメント等を依頼致します。具体的な内容は以下となります。\r\n〇デジタルマーケティング 企画から戦略立案、SEO対策や運用型広告対応など\r\n〇CRM/CS 領域における顧客分析・LTV最大化の施策立案・顧客からの問い合わせ体制及び運用体制の構築\r\n\r\n■募集背景\r\n例）現在、運営している自社ウェブサイト・EC、両者の統合及び最適化、更なる集客を企画し、実際にディレクションできる人材を募集致します。\r\n\r\n■固定報酬（補足）\r\n固定報酬に関して、補足事項がございましたらご記載ください。\r\n\r\n■稼働期間（補足）\r\n例）20〇〇年〇月～〇月の期間において、週〇時間程度の稼働を想定しています。\r\n\r\n■求めるスキル・経験\r\n例）・Webマーケティング・EC運営に関する実務経験\r\n　　・マネジメント経験\r\n\r\n■勤務形態/勤務地\r\n例）フルリモート（ミーティングはZoom等で実施いたします）',
        area2: '■クライアント事業概要\r\n例）大手アパレルメーカー。中価格帯ブランド軸を百貨店向け中心に展開。\r\n\r\n■クライアント区分 新規クライアントもしくは既存クライアントであるかを記載してください。\r\n\r\n■職務概要\r\n例）オムニチャネル化推進に伴う自社ウェブサイト・ECのマーケティング・運営・マネジメント等を依頼致します。具体的な内容は以下となります。\r\n〇デジタルマーケティング 企画から戦略立案、SEO対策や運用型広告対応など\r\n〇CRM/CS 領域における顧客分析・LTV最大化の施策立案・顧客からの問い合わせ体制及び運用体制の構築\r\n\r\n■募集背景\r\n例）現在、運営している自社ウェブサイト・EC、両者の統合及び最適化、更なる集客を企画し、実際にディレクションできる人材を募集致します。\r\n\r\n■時間単価（補足）\r\n時間単価に関して、補足事項がございましたらご記載ください。\r\n\r\n■稼働期間（補足）\r\n例）20〇〇年〇月～〇月の期間において、週〇時間程度の稼働を想定しています。\r\n\r\n■求めるスキル・経験\r\n例）・Webマーケティング・EC運営に関する実務経験\r\n　　・マネジメント経験\r\n\r\n■勤務形態/勤務地\r\n例）フルリモート（ミーティングはZoom等で実施いたします）',
      }
      radios.forEach(radio => {
        if( radio.checked && boxRequest && boxRequest.value == ''){
          if(radio.classList.contains('jsOption1')){
            boxRequest.value = dataTextAreaContent.area1;
          } else {
            boxRequest.value = dataTextAreaContent.area2;
          }
        }
        radio.addEventListener('change', () => {
          if( radio.checked ){
            if(radio.classList.contains('jsOption1')){
              block1.classList.add('active');
              block2.classList.remove('active');
              if(boxRequest){
                boxRequest.value = dataTextAreaContent.area1;
              }
            } else {
              block2.classList.add('active');
              block1.classList.remove('active');
              if(boxRequest){
                boxRequest.value = dataTextAreaContent.area2;
              }
            }
          }
        })
      })
    }
  }
}
function handleChangeRadioExpertChat() {
  const block = document.querySelector('.jsRadioContractChat ');
  if(block){
    const block1 = document.querySelector('.jsBlock1Chat ');
    const block2 = document.querySelector('.jsBlock2Chat ');
    const radios = block.querySelectorAll('.jsOptionChat');
    if(block1 && block2 && radios){
      radios.forEach(radio => {
        radio.addEventListener('change', () => {
          if( radio.checked ){
            if(radio.classList.contains('jsOptionChat1')){
              block1.classList.add('active');
              block2.classList.remove('active');
            } else {
              block2.classList.add('active');
              block1.classList.remove('active');
            }
          }
        })
      })
    }
  }
}
function handleChangeRadio3() {
  const block = document.getElementById('jsRadioTransaction');
  if(block){
    const radios = block.querySelectorAll('input[type=radio]');
    const box1 = block.querySelector('.jsBox1');
    const box2 = block.querySelector('.jsBox2');
    const button = block.querySelector('.jsButton');
    const boxChild2 = block.querySelector('.jsBoxChild2');
    radios.forEach(radio => {
      if( radio.checked ){
        if(radio.classList.contains('jsRadio1')){
          box1.classList.add('active');
          box2.classList.remove('active');
          if(button){
            button.classList.remove('active');
          }
          if(boxChild2){
            boxChild2.classList.remove('active');
          }
        } else {
          box2.classList.add('active');
          if(button){
            button.classList.add('active');
          }
          if(boxChild2){
            boxChild2.classList.add('active');
          }
          box1.classList.remove('active');
        }
      }
      radio.addEventListener('change', () => {
        if( radio.checked ){
          if(radio.classList.contains('jsRadio1')){
            box1.classList.add('active');
            box2.classList.remove('active');
            if(button){
              button.classList.remove('active');
            }
            if(boxChild2){
              boxChild2.classList.remove('active');
            }
          } else {
            box2.classList.add('active');
            if(button){
              button.classList.add('active');
            }
            if(boxChild2){
              boxChild2.classList.add('active');
            }
            box1.classList.remove('active');
          }
        } else {
          box1.classList.remove('active');
          box2.classList.add('active');
          if(button){
            button.classList.add('active');
          }
          if(boxChild2){
            boxChild2.classList.add('active');
          }
        }
      });
    });
  }
}

function handleAutoHeightTextarea({element}) {
  const textareas = document.querySelectorAll(element);
  if(textareas){
    textareas.forEach(textarea => {
      textarea.style.height= textarea.scrollHeight + 'px';
    })
  }
}

function handleTooltip () {
  const wraps = document.querySelectorAll('.jsTooltip');
  if(wraps){
    wraps.forEach( wrap => {
      const ttl = wrap.querySelector('.jsTooltipTrigger');
      const block = wrap.querySelector('.jsTooltipBlock');
      const table2 = wrap.closest('.jsTooltipTable2');
      if(ttl && block){
        ttl.addEventListener('click', (event) => {
          block.classList.add('active');
          ttl.classList.add('active');
          if( wrap.classList.contains('jsTooltipTable1') ){
            wrap.classList.add('style1');
          };
          if( table2 && window.innerWidth < 769){
            const heightBlock = block.offsetHeight;
            table2.style.paddingTop = heightBlock + 'px';
          };
          if( wrap.classList.contains('jsTooltipTable') ){
            wrap.classList.add('notScroll');
          };
          const tbl13Check = wrap.querySelector('.table13');
          if(tbl13Check){
            let leftArrow = event.target.getBoundingClientRect().left;
            if(leftArrow < 40){
              ttl.classList.remove('active');
            }
            tbl13Check.addEventListener('scroll', () => {
              block.classList.remove('active');
              ttl.classList.remove('active');
            });
          }
        });
        window.addEventListener('click', function (event) {
          if ( !ttl.contains(event.target) && !block.contains(event.target) && block.classList.contains('active')) {
            block.classList.remove('active');
            ttl.classList.remove('active');
            if( wrap.classList.contains('jsTooltipTable1') ){
              wrap.classList.remove('style1');
            };
            if( wrap.classList.contains('jsTooltipTable') ){
              wrap.classList.remove('notScroll');
            };
          }
          if( table2 && window.innerWidth < 769 && !event.target.classList.contains('jsTooltipTrigger')){
            table2.style.paddingTop = 0;
          };
        });
      }
    })
  }
}

function anchorFaqMove(id) {
  let anchorFaqTargetEl = document.getElementById(id),
    body = document.querySelector('body');
  if(anchorFaqTargetEl) {
    const eleHtml = document.querySelector('html'),
      overplay = document.getElementById('overplay'),
      modalSignup = document.getElementById('modalSignup');
    eleHtml.style.overflowY = 'visible';
    overplay.classList.remove('active');
    modalSignup.classList.remove('active');
    anchorFaqTargetEl.querySelectorAll('input')[0].checked = true;
    setTimeout(function() {
      anchorFaqTargetEl = document.getElementById(id);
      $('html, body').animate({ scrollTop: anchorFaqTargetEl.offsetTop - 120 }, 500);
    }, 500);
  }
}

function initAnchorFaq() {
  let hash = window.location.hash;
  if(hash == '#anchorfaq') {
    anchorFaqMove(hash.substring(1));
  }
}

function anchorFaq() {
  let anchorFaqEl = document.getElementById('jsAnchorFAQ');
  if(anchorFaqEl) {
    anchorFaqEl.addEventListener('click', function (e) {
      anchorFaqMove(anchorFaqEl.dataset.anchor);
      if(body.id == 'pageHomeExpert') {
        e.preventDefault();
      }
    });
  }
}

function handleFormatNumber(num) {
  const numResul = num.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return numResul;
}

function handleFullSizeToHalfSize (str) {
	return str.replace(/[！-～]/g, (text) => {
    return String.fromCharCode(text.charCodeAt(0) - 0xFEE0);
  })
}

function handleValidationInputNumber() {
  const inputEles = document.querySelectorAll('.jsValidationNumber');
  const regexNumber = /^[0-9０-９]+$/; 
  const regexNumberHalf = /^[0-9]+$/;
  if(inputEles) {
    inputEles.forEach( inputEle => {
      let isComposing = false; 
      let hasCompositionJustEnded = false;
      inputEle.addEventListener('compositionstart', (eventCompStart) => {
        isComposing = true;
      });
      inputEle.addEventListener('compositionend', (eventCompEnd) => {
        isComposing = false;
        hasCompositionJustEnded = true;
      });
      inputEle.addEventListener('input', (eventInput) => {
        if (isComposing || hasCompositionJustEnded) {
          if (regexNumber.test(eventInput.target.value)) {
            inputEle.value = eventInput.data;
          } else {
            inputEle.value = '';
          }
          hasCompositionJustEnded = false;
        } else {
          let valueCheck = handleFullSizeToHalfSize(eventInput.target.value).replace(/\D/g, "");
          if (regexNumber.test(valueCheck)) {
            inputEle.value = handleFormatNumber(valueCheck);
          } else {
            inputEle.value = '';
          }
        }
      });
      inputEle.addEventListener('blur', (eventBlur) => {
        let valueCheck = eventBlur.target.value;
        if(valueCheck){
          if (regexNumberHalf.test(valueCheck)) {
            inputEle.value = handleFormatNumber(valueCheck);
          }
        }
      });
      window.addEventListener('keydown', eventKeydown => {
        if (eventKeydown.which !== 229) {
          hasCompositionJustEnded = false;
        }
      })     
    })
  }
}

function handleSidebarModal() {
  if(window.innerWidth < 993){
    const openModal = document.getElementById("openSidebarModal");
    const modal = document.getElementById("sidebarModal");
    if (openModal && modal) {
      const btnClose = modal.querySelector(".jsBtnClose");
      openModal.addEventListener("click", function (e) {
        handleDisableScroll();
        e.stopPropagation();
        modal.classList.add("active");
      });
      btnClose.addEventListener("click", function (e) {
        handleEnableScroll();
        e.stopPropagation();
        modal.classList.remove("active");
      });
      modal.addEventListener("click", function (e) {
        if ( 
            !openModal.contains(e.target) && 
            e.target.classList.contains("wrapSidebar") 
          ) {
          handleEnableScroll();
          modal.classList.remove("active");
        }
      });
    }
  }
}

function handleSelectPlaceholder () {
  const selectList = document.querySelectorAll('.jsSelectPlaceholder');
  if(selectList){
    selectList.forEach(select => {
      select.addEventListener('change', () => {
        const isValue = select.value;
        if(isValue != ''){
          select.classList.add('active');
        } else {
          select.classList.remove('active');
        }
      })
    })
  }
}

window.addEventListener('load', function () {
  let headerBtnEl = document.getElementById('jsHeaderBtn'),
    headerNavEl = document.getElementById('jsNav'),
    headerEl = document.getElementById('header'),
    navCloseEl = document.getElementById('jsNavClose');
  if (headerBtnEl) {
    headerBtnEl.addEventListener('click', function (e) {
      headerNavEl.classList.add('expand');
      headerEl.classList.add('expand');
    });
    navCloseEl.addEventListener('click', function (e) {
      headerNavEl.classList.remove('expand');
      headerEl.classList.remove('expand');
    });
  }
  handleMinHeightContents();
  handleModal();
  handleModalAlertExpert();
  tabScroll();
  tabClick();
  tabOrderClick();
  tabCheckClick();
  handleTogglePassword();
  handleOpenModalSignUp();
  handleOpenModalLogin();
  handleAddFormCareer();
  handleShowDefaultValue();
  handlePageTop();
  customDatepicker();
  handleRemoveCareerFirst();
  handleToggleActive();
  handleToggleHistory();
  handleTriggerLink();
  rating();
  handleClickButtonChoose();
  handleTextMore1();
  handleInputCheckAll();
  handleFormEstimate();
  handleToggleAppType();
  handleTitleTicky1();
  handleChangeRadio1();
  handleChangeRadio2();
  handleChangeRadioExpertChat();
  handleChangeRadio3();
  handleScrollSidebar();
  handleScrollSidebar4();
  handleTooltip();
  handleToggleFavorite();
  handleValidationInputNumber();
  handleAutoHeightTextarea({
    element: '.jsAutoHeight',
  });
  initAnchorFaq();
  anchorFaq();
  handleSidebarModal();
  handleSelectPlaceholder();
});

window.addEventListener("scroll", function () {
  handleScrollSidebar();
  handleScrollSidebar2();
  handleScrollSidebar3();
  handleScrollSidebar4();
  tabScroll();
  handleTitleTicky1();
});

function timeoutResize() {}
let timerResize;
window.addEventListener("resize", function () {
  clearTimeout(timerResize);
  timerResize = setTimeout(timeoutResize, 300);
});
document.addEventListener("DOMContentLoaded", function () {
  const lazyDefault = new LazyLoad({
    elements_selector: ".jsLazy",
  });
});
